import { render, staticRenderFns } from "./SlitherApp.vue?vue&type=template&id=f4e0b994&"
import script from "./SlitherApp.vue?vue&type=script&lang=js&"
export * from "./SlitherApp.vue?vue&type=script&lang=js&"
import style0 from "./SlitherApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports